import service from "@/api/service";
import { RankPointUserCSVGetRequest } from "@/api/analysis/rank-point-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * ランク(ポイント)ユーザーCSV出力APIをコールします。
 *
 * @param getRequest ランク(ポイント)ユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: RankPointUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-rank-point-user-csv",
    getRequest)
  ;
  return response as DownloadCSVResponse;
}
